
export enum FinalStandardAddressSourceCd {
	ADDRESS_VALIDATION_API_UNAVAILABLE = 'AddressValidationApiUnavailable',
	GOOGLE_STANDARD_ADDRESS = 'GoogleStandardAddress',
	PITNEY_BOWES_STANDARD_ADDRESS = 'PitneyBowesStandardAddress',
	UNABLE_TO_VALIDATE_ADDRESS_FROM_LOTUS = 'UnableToValidateAddressFromLotus'}

